import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Department, UpdateDepartmentInput } from '../../domain/models/department.model';
import { DepartmentProfile, UpdateDepartmentProfileInput } from '../../domain/models/department-profile.model';
import { IDepartmentsAdminRepository } from '../../domain/repositories/departments-admin.repository';
import { DepartmentsAdminRemoteDatasource } from '../datasources/remote/departments-admin.remote-datasource';
import { DepartmentAdminMapper } from '../mappers/department-admin.mapper';
import { DepartmentProfileMapper } from '../mappers/department-profile.mapper';

@Injectable()
export class DepartmentsAdminRepositoryImpl implements IDepartmentsAdminRepository {
  private readonly datasource = inject(DepartmentsAdminRemoteDatasource);
  private readonly mapper = inject(DepartmentAdminMapper);
  private readonly profileMapper = inject(DepartmentProfileMapper);

  public list(organizationId: number): Observable<readonly Department[]> {
    return this.datasource.list(organizationId).pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toDepartment(dto))),
    );
  }

  public update(organizationId: number, departmentId: number, input: UpdateDepartmentInput): Observable<Department> {
    return this.datasource.update(organizationId, departmentId, {
      Name: input.name,
      ResponsibleEmail: input.responsibleEmail,
      TimeZone: input.timeZone,
      IsActive: input.isActive,
      Email: input.email,
    }).pipe(
      map((dto) => this.mapper.toDepartment(dto)),
    );
  }

  public getProfile(organizationId: number, departmentId: number): Observable<DepartmentProfile> {
    return this.datasource.getProfile(organizationId, departmentId).pipe(
      map((dto) => this.profileMapper.toDomain(dto)),
    );
  }

  public updateProfile(
    organizationId: number,
    departmentId: number,
    input: UpdateDepartmentProfileInput,
  ): Observable<DepartmentProfile> {
    return this.datasource.updateProfile(organizationId, departmentId, this.profileMapper.toUpdatePayload(input)).pipe(
      map((dto) => this.profileMapper.toDomain(dto)),
    );
  }
}
